/**
 * Palette KEYS only; the actual colors live in the web app's tokens.css as
 * --sf-<key> variables (invariant 5: no hex outside tokens.css).
 */
export const SHARED_FOLDER_COLORS = [
    "gray",
    "red",
    "orange",
    "yellow",
    "green",
    "teal",
    "blue",
    "purple",
    "pink",
];
export function isSharedFolderColor(v) {
    return SHARED_FOLDER_COLORS.includes(v);
}
/** Bounds the quota fan-out (3 size queries per folder) and invite abuse. */
export const MAX_SHARED_FOLDERS_PER_USER = 20;
export const MAX_MEMBERS_PER_FOLDER = 50;
export const SHARED_FOLDER_INVITE_TTL_DAYS = 7;
export const MAX_SHARED_FOLDER_TITLE = 200;
/** True when the role may modify note content and the tree. */
export function canEdit(role) {
    return role === "owner" || role === "editor";
}
//# sourceMappingURL=sharedFolders.js.map